<template>
    <div @mouseleave="StartCloseTimer" @mouseenter="StopCloseTimer">
        <div class="context_menu_btn" ref="context_menu_btn" @mouseenter="StartOpenTimer" @mouseleave="StopOpenTimer" @click="$emit('Click')">
            <slot name="img" />
            &nbsp;{{title}}
            <img v-if="HasSubmenu" @click="ShowFlyout = !ShowFlyout" class="theme-svg" style="margin-left: auto;" src="../../../../public/icons/arrow_right.svg">
        </div>

        <ContextMenuFlyout v-if="ShowFlyout" :ParentRect="BoundingClientRect">
            <template v-slot:buttons>
                <slot name="submenu" />
            </template>
        </ContextMenuFlyout>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-facing-decorator';
    import ContextMenuFlyout from "./ContextMenuFlyout.vue";

    @Component({ name: "ContextMenuButton", components: { ContextMenuFlyout } })
    export default class ContextMenuButton extends Vue {
        @Prop() title!: string;

        public get BoundingClientRect(): DOMRect {
            return (this.$refs.context_menu_btn as HTMLDivElement).getBoundingClientRect();
        }

        private get HasSubmenu(): boolean {
            return !!this.$slots.submenu;
        }

        private ShowFlyout: boolean = false;
        openTimer: ReturnType<typeof setTimeout> | null = null;
        private StartOpenTimer() {
            if (this.HasSubmenu) {
                this.openTimer = setTimeout(() => {
                    this.ShowFlyout = true;
                }, 400);
            }
        }
        private StopOpenTimer() {
            if (this.openTimer) {
                clearTimeout(this.openTimer);
                this.openTimer = null;
            }
        }

        closeTimer: ReturnType<typeof setTimeout> | null = null;
        private StartCloseTimer() {
            this.closeTimer = setTimeout(() => {
                if (this.HasSubmenu)
                    this.ShowFlyout = false;
            }, 1000);
        }
        private StopCloseTimer() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer);
                this.closeTimer = null;
            }
        }
    }
</script>

<style scoped>
    .curtain {
        opacity: 0;
        position: fixed;
        z-index: 300;
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
    }
</style>
